/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbox_Empty_DescInputs */

const en_inbox_empty_desc = /** @type {(inputs: Inbox_Empty_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buyers will reach out when they're interested in your listings.`)
};

const es_inbox_empty_desc = /** @type {(inputs: Inbox_Empty_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los compradores se pondrán en contacto cuando estén interesados en tus anuncios.`)
};

const fr_inbox_empty_desc = /** @type {(inputs: Inbox_Empty_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les acheteurs vous contacteront lorsqu'ils seront intéressés par vos annonces.`)
};

const de_inbox_empty_desc = /** @type {(inputs: Inbox_Empty_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Käufer werden sich melden, wenn sie an deinen Inseraten interessiert sind.`)
};

const ja_inbox_empty_desc = /** @type {(inputs: Inbox_Empty_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`購入者があなたの出品に興味を持った場合に連絡が来ます。`)
};

const zh_inbox_empty_desc = /** @type {(inputs: Inbox_Empty_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当买家对您的商品感兴趣时，他们会联系您。`)
};

const ar_inbox_empty_desc = /** @type {(inputs: Inbox_Empty_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سيتواصل معك المشترون عندما يكونون مهتمين بإعلاناتك.`)
};

const id_inbox_empty_desc = /** @type {(inputs: Inbox_Empty_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pembeli akan menghubungi Anda saat mereka tertarik dengan listing Anda.`)
};

const it_inbox_empty_desc = /** @type {(inputs: Inbox_Empty_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gli acquirenti ti contatteranno quando saranno interessati ai tuoi annunci.`)
};

const ru_inbox_empty_desc = /** @type {(inputs: Inbox_Empty_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Покупатели свяжутся с вами, если их заинтересуют ваши объявления.`)
};

const pt_inbox_empty_desc = /** @type {(inputs: Inbox_Empty_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os compradores entrarão em contato quando estiverem interessados em seus anúncios.`)
};

const ko_inbox_empty_desc = /** @type {(inputs: Inbox_Empty_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`구매자가 상품에 관심이 있으면 연락할 것입니다.`)
};

/**
* | output |
* | --- |
* | "Buyers will reach out when they're interested in your listings." |
*
* @param {Inbox_Empty_DescInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const inbox_empty_desc = /** @type {((inputs?: Inbox_Empty_DescInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_Empty_DescInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_inbox_empty_desc(inputs)
	if (locale === "es") return es_inbox_empty_desc(inputs)
	if (locale === "fr") return fr_inbox_empty_desc(inputs)
	if (locale === "de") return de_inbox_empty_desc(inputs)
	if (locale === "ja") return ja_inbox_empty_desc(inputs)
	if (locale === "zh") return zh_inbox_empty_desc(inputs)
	if (locale === "ar") return ar_inbox_empty_desc(inputs)
	if (locale === "id") return id_inbox_empty_desc(inputs)
	if (locale === "it") return it_inbox_empty_desc(inputs)
	if (locale === "ru") return ru_inbox_empty_desc(inputs)
	if (locale === "pt") return pt_inbox_empty_desc(inputs)
	return ko_inbox_empty_desc(inputs)
});